import { SearchCriteria } from "./search-criteria";

export class GetGymClientMembershipClassesSearchCriteria extends SearchCriteria {
  public GymClientMembershipId: number;
}
